__turbopack_context__.v({
  "SearchBar": "SearchBar-module__KdGN3G__SearchBar",
  "SearchFullUI": "SearchBar-module__KdGN3G__SearchFullUI",
  "SearchMobileBottom": "SearchBar-module__KdGN3G__SearchMobileBottom",
  "backButton": "SearchBar-module__KdGN3G__backButton",
  "bottom": "SearchBar-module__KdGN3G__bottom",
  "btn": "SearchBar-module__KdGN3G__btn",
  "button": "SearchBar-module__KdGN3G__button",
  "closeButton": "SearchBar-module__KdGN3G__closeButton",
  "closing": "SearchBar-module__KdGN3G__closing",
  "contents": "SearchBar-module__KdGN3G__contents",
  "hide": "SearchBar-module__KdGN3G__hide",
  "icon": "SearchBar-module__KdGN3G__icon",
  "input": "SearchBar-module__KdGN3G__input",
  "lg": "SearchBar-module__KdGN3G__lg",
  "mobile": "SearchBar-module__KdGN3G__mobile",
  "name": "SearchBar-module__KdGN3G__name",
  "opacity": "SearchBar-module__KdGN3G__opacity",
  "opacityOut": "SearchBar-module__KdGN3G__opacityOut",
  "overlay": "SearchBar-module__KdGN3G__overlay",
  "product": "SearchBar-module__KdGN3G__product",
  "searchDropdown": "SearchBar-module__KdGN3G__searchDropdown",
  "slideInY": "SearchBar-module__KdGN3G__slideInY",
  "slideOutY": "SearchBar-module__KdGN3G__slideOutY",
  "sm": "SearchBar-module__KdGN3G__sm",
  "small": "SearchBar-module__KdGN3G__small",
  "suggestedSearch": "SearchBar-module__KdGN3G__suggestedSearch",
  "suggestedSearchItem": "SearchBar-module__KdGN3G__suggestedSearchItem",
  "top": "SearchBar-module__KdGN3G__top",
});
